<template>
  <PageWrapper
    :active-section="SECTION_SETTINGS"
    :active-page="PAGE_USER_PUBLICATIONS"
    title="Joined Publications"
    :breadcrumbs="breadcrumbs"
    page-name="Joined Publications"
    align="left"
    width="full"
  >
    <SmartFeed
      :source="useUserPublicationFeedStore"
      default-feed-layout="grid"
      default-entity-size="small"
      load-more-behavior="auto"
    >
      <template #empty-state>
        <iSpace :height="40" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No Publications Found
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              Publications you are apart of will appear here
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { SECTION_SETTINGS, PAGE_USER_PUBLICATIONS } from "@/constants/nav-constants";
import { useUserPublicationFeedStore } from "@/smart-feed/stores/feed/user-publication-feed-store";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";

export default {
  name: "UserPublications",
  components: { PageWrapper, SmartFeed },
  data() {
    return {
      SECTION_SETTINGS,
      PAGE_USER_PUBLICATIONS,
    };
  },
  computed: {
    breadcrumbs() {
      return [{ url: "/", label: "Home" }];
    },
  },
  methods: { useUserPublicationFeedStore },
};
</script>
